import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, map, filter } from 'rxjs/operators';
import AppState from '../../state';
import { UpdateField } from '../action-creators';
import { UPDATE_TRACK_FIELD } from '../../tracks/actions';
import { trackList } from '@webapp/store/tracks/selectors';
import { UpdateTrackField } from '@webapp/store/tracks/action-creators';

export const updateIsExplictEpic = (action$: Observable<UpdateTrackField<'isExplicit'>>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<UpdateTrackField<'isExplicit'>>(
      UPDATE_TRACK_FIELD
    ),
    filter((action) => action.field === 'isExplicit'),
    withLatestFrom(state$),
    map(([action, state]) => {
      const tracks = trackList(state.tracks.tracks, state.release.release?.id);

      return new UpdateField<'isExplicit'>('isExplicit', action.value || tracks.some((t) => t.isExplicit));
    })
  );